import { CourseListConstants } from '../_constants';

export function courseSetting(state = {}, action) {
  switch (action.type) {
    case CourseListConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case CourseListConstants.GETALL_SUCCESS:
      return {
        courseSetting: action.courseSetting
      };
    case CourseListConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/course-settings.reducer.js